import Vue from 'vue';
import { gsap, Quad } from 'gsap';

Vue.component('faq-expand-component', {

    data() {
        return {
            //
        }
    },

    mounted() {

    },

    methods: {
        openFaqItem(e) {
            const clickedEl = e.target
            const icon = clickedEl.querySelector('svg');
            const content = clickedEl.parentNode.querySelector('.faq-expand__item__content')

            if (icon.classList.contains('active')) {
                icon.classList.remove('active');
                gsap.to(content, 0.3, {
                    height: 0,
                    ease: Quad.easeOut,
                });
                return;
            }

            icon.classList.add('active');
            gsap.to(content, 0.3, {
                height: 'auto',
                ease: Quad.easeOut,
            });

        }
    },

    filters: {
        capatalize(value) {
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },

    beforeDestroy() {

    }
});